import React, {useState, useEffect} from 'react';
import DataGridTable from '../../../Components/DataGrid';
import { GridRowModes } from '@mui/x-data-grid';
import { useSelector } from 'react-redux';
import { handleValidateCodevalue, ROWS_TO_VIEW_IN_CHILD_TABLE } from '../../../Utility/constant';
const CreateSystemLookup = ({lookupdetails,  enqueueSnackbar, currentActiveLookup, handleUpdateSystemrecord}) => {
    
  const internationalise = useSelector((state) => state?.internationalise?.currentHashMapData);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [rows, setRows] = React.useState([]);
    const [dataGridData, setDatagridData] = useState([])
    const [addeditsystemlookup, setaddeditlookupsystem] = useState(null)


    useEffect(() => {
      if(lookupdetails?.systemlookup?.length > 0) {
        setDatagridData(lookupdetails?.systemlookup?.sort((a,b) => new Date(b?.updated).valueOf() - new Date(a?.updated).valueOf()));
      }
    },[lookupdetails?.systemlookup])
  
    const handleDeleteLookup = (id) => () => {

    }

    const handleSaveClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };
  
    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    
    const handleCancelClick = (id) => () => {
        setRowModesModel({
          ...rowModesModel,
          [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    
        const editedRow = dataGridData.find((row) => row.id === id);
        if (editedRow.isNew) {
            setDatagridData(dataGridData.filter((row) => row.id !== id));
        }
      };

    const handleAddClick = () => {
        let id = "";
        setDatagridData((oldRows) => [{id, name: "", status: 'ACTIVE', sequence: "", isNew: true }, ...oldRows]);
        setRowModesModel((oldModel) => ({
          ...oldModel,
          [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
        }));
    };

    const handleChange = (event) => {
      setaddeditlookupsystem({
        ...addeditsystemlookup,
        [event.target.name]: event.target.value
      })
    }
    
    
    const systemlookupcodeColumn = [
        
        {
          field: 'name', 
          headerName: handleValidateCodevalue(internationalise,'CONF_LU_EDIT_SLC'),
          flex: 1,
          editable: true
        },
        
        // {
        //   field: 'sequence', 
        //   headerName: 'Sequence', 
        //   flex: 1,
        //   editable: true,
        //   renderEditCell: (params) => (
        //     <TextField
        //         id="standard-sequence"
        //         type='number'
        //         InputLabelProps={{
        //             shrink: true,
        //         }}
        //         style={{width: "100%"}}
        //         name="sequence"
        //         onChange={handleChange}
        //     >

        //     </TextField>

        //   )
        // },

        {
          field: 'status', 
          headerName: handleValidateCodevalue(internationalise,'LU_STATUS'),
          flex: 1,
          editable: false
        },

        // {
        //     field: 'actions',
        //     type: 'actions',
        //     headerName: 'Actions',
        //     width: 100,
        //     cellClassName: 'actions',
        //     getActions: ({ id }) => {
        //       const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
      
        //       if (isInEditMode) {
        //         return [
        //           <GridActionsCellItem
        //             icon={<CheckIcon />}
        //             label="Save"
        //             className="textPrimary"
        //             onClick={handleSaveClick(id)}
        //           />,
        //           <GridActionsCellItem
        //             icon={<CancelIcon />}
        //             label="Cancel"
        //             className="textPrimary"
        //             onClick={handleCancelClick(id)}
        //             color="inherit"
        //           />,
        //         ];
        //       }
      
        //       return [
        //         <GridActionsCellItem
        //           icon={<EditIcon />}
        //           label="Edit"
        //           className="textPrimary"
        //           onClick={handleEditClick(id)}
        //           color="inherit"
        //         />
        //         // <GridActionsCellItem
        //         //   icon={<DeleteIcon />}
        //         //   label="Edit"
        //         //   className="textPrimary"
        //         //   onClick={handleDeleteLookup(id)}
        //         //   color="inherit"
        //         // />,
        //       ];
        //     },
        // },
    ]

    const handleUpdaterecord = (newdata) => {

      if(!newdata?.name) {
          setRowModesModel({ ...rowModesModel, [newdata?.id]: { mode: GridRowModes.Edit } });
         enqueueSnackbar("Please enter system lookup name", {variant: "warning"});
      } else {
        
        setRowModesModel({ ...rowModesModel, [newdata?.id]: { mode: GridRowModes.View } });
       
        handleUpdateSystemrecord(newdata, addeditsystemlookup);
      } 
    
    }

    return (
            <DataGridTable
                showFilter={false}
                columns={systemlookupcodeColumn}
                dataGridData={dataGridData}
                rowsToView = {ROWS_TO_VIEW_IN_CHILD_TABLE}
                height='calc(100vh - 350px)'
                rowModesModel = {rowModesModel}
                // gridType = "systemlookup"d
                handleUpdateProduct = {handleUpdaterecord}
                // isLoading = {lookupdetails?.isSystemLoader}
                isCheckboxReq={false}
            
            />
        )
}

export default CreateSystemLookup;